import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';

import Button from '../../components/common/Button';

import './MultiProjectsModal.scss';
import handlePath from '../../utils/handlePath';
import { MyModal } from '../../components/common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import startCase from 'lodash-es/startCase';
import dayjs from 'dayjs/esm';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);

const MultiProjectsModal = ({ isOpen, handleCloseModal, workflow = {} }) => {
  const { companyId } = useParams();
  const history = useHistory();
  const { projects = [], label, status, isPortals } = workflow;
  const customStyles = {
    overlay: {
      zIndex: 9,
      backgroundColor: 'rgba(0,0,0,.66)',
      position: 'fixed',
      height: '100vh',
      width: '100vw',
      display: 'flex',
    },
    content: {
      position: 'static',
      maxWidth: '80%',
      maxHeight: '80%',
      margin: 'auto',
      borderRadius: 12,
    },
  };

  return (
    <MyModal isOpen={isOpen} onRequestClose={handleCloseModal} style={customStyles}>
      <div className="multi-projects-modal">
        <div className="multi-projects__top">
          <h2>{label} Options:</h2>
          <FontAwesomeIcon
            className="multi-projects__exit"
            onClick={handleCloseModal}
            icon="times"
          />
        </div>
        <div className="multi-projects__cards">
          {!isPortals && (
            <div
              onClick={() => {
                history.push(handlePath(`/workbench/1/${workflow.id}/-1/new`, companyId));
              }}
              className="multi-projects__card"
            >
              <div className="multi-projects__card-col">
                <h4 className="multi-projects__card-status">{startCase(status)}</h4>
                <p>{label}</p>
              </div>
              <Button size="sm">
                Start New
                <FontAwesomeIcon icon="chevron-right" />
              </Button>
            </div>
          )}
          {projects.map((project, ind) => {
            return (
              <div
                onClick={() => {
                  history.push(
                    handlePath(`/workbench/1/${project.id}/-1/initialize`, companyId),
                  );
                }}
                className="multi-projects__card"
                key={`projects-${ind}`}
              >
                <div className="multi-projects__card-col">
                  <h4
                    className={`multi-projects__card-status ${
                      (project.status === 'closed' && '') ||
                      (project.status === 'pending' &&
                        'multi-projects__card-status--med') ||
                      'multi-projects__card-status--low'
                    }`}
                  >
                    {startCase(project.status) || 'Assessment Started'}
                  </h4>
                  <p>{project.label}</p>
                  <h4>{dayjs(project.created_at).format('L')}</h4>
                </div>
                <FontAwesomeIcon
                  className="multi-projects__card-chevron"
                  icon="chevron-right"
                />
              </div>
            );
          })}
        </div>
        {/* <div className="multi-projects__buttons">
          <Button buttonType="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button to={handlePath(`/workbench/1/${workflow.id}/-1/new`, companyId)}>
            Create New
          </Button>
        </div> */}
      </div>
    </MyModal>
  );
};

MultiProjectsModal.propTypes = {
  formData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string, //TODO: clean up Review PropTypes
            value: PropTypes.string,
          }),
        ),
      ]),
    }),
  ),
  title: PropTypes.string,
};

export default MultiProjectsModal;
